let currentActiveSize = null;

class SizeSelectors extends HTMLElement {
  constructor() {
    super();
    this.sizeButtons = this.querySelectorAll('button');
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  connectedCallback() {
    this.sizeButtons.forEach(button => {
      button.addEventListener('click', this.handleButtonClick);
    });
  }

  handleButtonClick(event) {
    const selectedButton = event.target;
    const selectedVariantId = selectedButton.dataset.variantId;

    currentActiveSize = selectedButton.textContent;

    this.sizeButtons.forEach(button =>
      button.classList.toggle('main-product__size-select--active', button === selectedButton)
    );

    const formElement = document.querySelector('.main-product__form');
    const productIdInput = formElement?.querySelector('input[name="id"]');
    if (productIdInput) {
      productIdInput.value = selectedVariantId;
    }
  }

  disconnectedCallback() {
    this.sizeButtons.forEach(button => {
      button.removeEventListener('click', this.handleButtonClick);
    });
  }
}

if (!customElements.get('size-selectors')) {
  customElements.define('size-selectors', SizeSelectors);
}

class ColorSwitcher extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', async () => {
      const productHandle = this.dataset.productHandle;
      const sectionId = this.dataset.sectionId;

      try {
        document.body.classList.add('request--pending')

        const response = await fetch(`${productHandle}?section_id=${sectionId}`);
        const responseText = await response.text();

        const newUrl = `/products/${productHandle}`;
        history.replaceState({}, '', newUrl);

        const parser = new DOMParser();
        const parsedHtml = parser.parseFromString(responseText, 'text/html');

        if (currentActiveSize) {
          const sizeButtons = parsedHtml.querySelectorAll('size-selectors button');
          const matchedButton = Array.from(sizeButtons).find(
            button => button.textContent === currentActiveSize
          );

          if (matchedButton) {
            sizeButtons.forEach(button =>
              button.classList.toggle('main-product__size-select--active', button.textContent === currentActiveSize)
            );

            const activeSizeButton = parsedHtml.querySelector('size-selectors button.main-product__size-select--active');
            parsedHtml.querySelector('.main-product__form input[name="id"]').value = activeSizeButton.dataset.variantId;
          }
        }

        const quantityInput = document.querySelector('.main-product__form #Quantity')

        if(quantityInput) {
          parsedHtml.querySelector('.main-product__form #Quantity').value = quantityInput.value
        }

        const selectorsToUpdate = [
          '.main-product__swiper-container',
          '.info__collection-wrapper',
          '.info__title',
          '.info__rating',
          '.info__price-wrapper',
          '.info__variants',
          '.info__description',
          '.main-product__form'
        ];

        selectorsToUpdate.forEach(selector => {
          const newElement = parsedHtml.querySelector(selector);
          const currentElement = document.querySelector(selector);
          if (currentElement && newElement) {
            currentElement.replaceWith(newElement);
          }
        });

        this.updateGallery()
      } catch (error) {
        return console.error('ColorSwitcher: ' + error);
      } finally {
        document.body.classList.remove('request--pending')
      }
    });
  }

  updateGallery() {
    const sliderElements = document.querySelectorAll("[data-slider-selector]");

    sliderElements.forEach(slider => new SwiperConfigurator(slider));
  }
}

if (!customElements.get('color-switcher')) {
  customElements.define('color-switcher', ColorSwitcher);
}

document.addEventListener('DOMContentLoaded', function () {
  const detailsElements = document.querySelectorAll('details');

  detailsElements.forEach(function (details) {
    if (details.open) {
      details.classList.add('is-open-details');
    }

    details.addEventListener('toggle', function () {
      if (this.open) {
        detailsElements.forEach(function (otherDetails) {
          if (otherDetails !== details && otherDetails.open) {
            otherDetails.open = false;
            otherDetails.classList.remove('is-open-details');
          }
        });

        this.classList.add('is-open-details');

        setTimeout(function () {
          details.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        }, 100);
      } else {
        this.classList.remove('is-open-details');
      }
    });
  });
});